import { useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { MapPresenter } from '../MapPresenter';
import { FeedbackItem } from '../services/FeedbacksService';

export function useFeedbacks(presenter: MapPresenter) {
    const [visible, setVisible] = useState<boolean>(false);
    const [items, setItems] = useState<FeedbackItem[]>([]);

    const toggle = useCallback(async (date: string) => {
        if (visible) {
            presenter.feedbacks.clear();
            setVisible(false);
            return;
        }

        const results = await presenter.feedbacks.show(date);
        const hasAny = (results?.length || 0) > 0;
        setItems(results);
        setVisible(!visible);
        if (!hasAny) {
            toast.info("No feedbacks found for this date");
        }
    }, [visible, presenter]);

    const show = useCallback(async (date: string) => {
        const results = await presenter.feedbacks.show(date);
        setItems(results);
        setVisible(true);
        if ((results?.length || 0) === 0) {
            toast.info("No feedbacks found for this date");
        }
    }, [presenter]);

    return {
        visible,
        items,
        toggle,
        show,
    };
}
